// @core/api/endpoints/billing/list_invoice_numbering_schemes.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListInvoiceNumberingSchemesResponse,
} from '../../../types/billing';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/billing';

/**
 * List invoice numbering schemes
 * Returns invoice numbering schemes, optionally filtered by scope.
 */
export async function ListInvoiceNumberingSchemes(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListInvoiceNumberingSchemesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/invoice-numbering-schemes`;
  const requestOptions = options;
  return client.get<ListInvoiceNumberingSchemesResponse>(requestPath, { ...requestOptions, params });
}
